module.exports = "<div class=\"container m-t-30\" [ngClass]=\"{ 'moving': moving }\">\n\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n\n            <div dashboard-container [(containers)]=\"containers\" [index]=\"0\"></div>\n        </div>\n\n        <div class=\"col-md-6\">\n\n            <div dashboard-container [(containers)]=\"containers\" [index]=\"1\"></div>\n        </div>\n    </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/two-column-layout/two-column-layout.component.html
// module id = ./libs/chassis-core/src/app/dashboards/components/two-column-layout/two-column-layout.component.html
// module chunks = main